import PropTypes from 'prop-types';

import Screens from './Screens';
import Steps from '../../components/Steps';
import messages from './CheckoutLayout.messages';

import CustomerCheck from '../../components/CustomerCheck';
import PageTitle from '../../components/PageTitle';
import DefaultLayout from '../DefaultLayout';

const CheckoutLayout = ({ children, ...props }) => (
  <DefaultLayout {...props}>
    <CustomerCheck>
      <PageTitle>{messages.title}</PageTitle>
      <Steps />
      <Screens>{children}</Screens>
    </CustomerCheck>
  </DefaultLayout>
);

CheckoutLayout.propTypes = {
  children: PropTypes.element.isRequired,
  route: PropTypes.shape({
    name: PropTypes.string.isRequired,
  }).isRequired,
};

export default CheckoutLayout;
